import React from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO } from '..';

import style from './PressKitPage.module.less';

export const PressKitPage = () => (
  <Layout>
    <SEO title="Press Kit" description="Press Kit for the 'Unboxing the mind of a Cryptic Killer game' - a cooperative online escape room experience in your browser" />

    <Section className={classnames(style.section, style.firstSection)}>
      <div className={classnames(style.content, style.contentNarrow, style.row)}>
        <div className={style.text}>
          <h1>Press kit</h1>

          <p>Below you'll find a link to our Google Drive, which we update regularly. Folders contain game assets and our company logo.</p>
          <p>Note that each game folder also contains a file named info.txt. In this file, you'll find information about the game, contact info, social media links, game description, and much more.</p>

          <div className={style.downloadWrapper}>
            <a href="https://drive.google.com/drive/folders/17mNjmlfDEaUlCDNhpi-cbXdQxPniA7Sd?usp=sharing" target="_blank">Download Press Kit</a>
          </div>
        </div>
      </div>
    </Section>
  </Layout>
);
